export enum SettlementRequestEnums {
  All,
  AllRequest,
  Pending,
  ExportToExcelClick,
  FilterClick,
  SearchClick,
}
